/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';

import { CustomGrid } from '../../../../assets/style/globalStyle';
import { Stack, Typography, Button, Card, Grid, Container } from '@mui/material';
import { isMobile } from 'react-device-detect';

import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';

const Docs = (props) => {
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  const handleClick = () => {
    if (infoState.id_type_user === 1) {
      window.open(
        'https://noisy-move-c93.notion.site/Documentos-1588ad4e6b4a80939e34df84c9c98390?pvs=74',
        '_blank'
      );
    } else {
      window.open(
        'https://noisy-move-c93.notion.site/Bem-vindo-ao-Portal-do-Parceiro-Phorm-1578ad4e6b4a80abb8b9d39d0a226c70?pvs=74',
        '_blank'
      );
    }
  };

  return (
    <RenderPage title="validationToken">
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              {infoState.id_type_user === 1 ? (
                <Typography variant="h4" gutterBottom>
                  Documentação interna
                </Typography>
              ) : (
                <Typography variant="h4" gutterBottom>
                  Documentação do sistema de parceiros
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              {infoState.id_type_user === 1 ? (
                <Typography variant="subtitle2" gutterBottom>
                  Utilize a documentação abaixo para tirar duvidas a respeito do sistema
                </Typography>
              ) : (
                <Typography variant="subtitle2" gutterBottom>
                  Utilize a documentação abaixo para tirar o maximo de proveito do nosso portal!
                </Typography>
              )}
            </Grid>
          </Grid>
          {!isMobile && (
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/dashboard"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            </Stack>
          )}
        </Stack>

        <Card>
          <CustomGrid>
            <Stack direction="row" justifyContent="center" sx={{ ml: 0, mb: 3, mt: 1 }}>
              <Button
                onClick={handleClick}
                variant="contained"
                size="medium"
                color="success"
                sx={{ mt: 1.7 }}
                style={{ height: 40 }}>
                Acessar Documentação
              </Button>
            </Stack>
          </CustomGrid>
        </Card>
      </Container>
    </RenderPage>
  );
};

export default Docs;
